<template>
    <div class="home_box">
        <!-- 首屏内容 -->
        <div class="news_video" :style="{height:viewportHeight+'px'}">
            <div class="heizhao">
                <p style="font-size: 80px;font-weight: 600;">发现音乐与漫画的</p>
                <p class="gradient-text-vertical">无限可能</p>
                <p style="font-size: 20px; margin-top: 30px;">探索海量优质音乐素材与漫画内容，激发你的创意灵感</p>
                <div class="liulan">
                    <div class="anniu_ka" @click="$router.push('/sucai')">浏览音乐素材</div>
                    <div class="anniu_ka" @click="$router.push('/manhua')">探索漫画世界</div>
                </div>
            </div>
            <video autoplay loop muted src="https://yanghl.oss-cn-beijing.aliyuncs.com/randi/style/1.mp4"></video>
        </div>
        
        <!-- 第二屏 -->
        <div class="two_fenlei">
            <div class="tilte_fenlei">
                <h1>分类浏览</h1>
                <p>快速找到你喜欢的音乐风格和漫画类型，发现更多精彩内容</p>
            </div>
            <!-- 按分类浏览 -->
            <div class="cards">
                <div
                    v-for="cat in categories"
                    :key="cat.key"
                    class="card-container"
                    role="button"
                    tabindex="0"
                    @click="goCategory(cat.key)"
                    @keydown.enter.prevent="goCategory(cat.key)"
                >
                    <div class="card-flipper">
                        <div class="card card-front" :style="cardStyle(cat.img)">
                            <div class="card-icon">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
                                </svg>
                            </div>
                            <div class="card-content">
                                <h3>{{ cat.title }}</h3>
                                <span class="card-subtitle">{{ cat.count }} 条内容</span>
                            </div>
                            <div class="card-hint">
                                <span>{{ cat.desc }}</span>
                            </div>
                        </div>
                        <div class="card card-back">
                            <div class="card-back-overlay"></div>
                            <div class="card-detail-content">
                                <div class="card-back-header">
                                    <h3>{{ cat.title }}</h3>
                                    <span class="badge-count">{{ cat.count }} 条</span>
                                </div>
                                <p class="card-description">{{ cat.desc }}</p>
                                <div class="card-stats">
                                    <div class="stat-item">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                            <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M17 11l-4-4-4 4M13 1v4m0 0v4"/>
                                        </svg>
                                        <div>
                                            <span class="stat-label">播放量</span>
                                            <span class="stat-value">{{ cat.play || '—' }}</span>
                                        </div>
                                    </div>
                                    <div class="stat-item">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                                            <polyline points="14 2 14 8 20 8"/>
                                        </svg>
                                        <div>
                                            <span class="stat-label">更新</span>
                                            <span class="stat-value">{{ cat.update || '最近' }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 第三屏 -->
        <div class="sanping_box">
            <div class="kuang_qian">
                <div class="tlite_sanPing">
                    <h2>热门音乐素材</h2>
                    <div class="leixuan_div">
                        <p>高品质背景音乐、音效和歌曲、适用于视频制作、游戏开发和创意项目</p>
                        
                    </div>
                </div>
                <div class="kuang_jia">
                    <div class="sanKang" v-for="(item,index) in rmYlist" :key="index" style="position: relative;"
                        @click="$router.push('/sucai')"
                        @mouseenter="handleVideoPlay(index)"
                        @mouseleave="handleVideoPause(index)">
                        <div class="F_img">
                            <video :autoplay="Hover_fuguo===index" muted 
                            ref="videoRefs"
                            playsinline webkit-playsinline
                            :src="item.videourl"></video>
                        </div>
                        <p style="position: absolute; z-index: 5; top: 10px; left: 10px; font-size: 15px; color: #fff; padding: 5px 10px; border-radius: 50px;
                        background-color: #000;" 
                        >{{item.name}}</p>
                    </div>
                </div>
            </div>
            <div class="chakan_dengduo" @click="$router.push('/sucai')">查看更多音乐素材 →</div>
        </div>
        <!-- 第四屏 -->
        <div class="sanping_box" style="background-color: #fff;">
            <div class="kuang_qian">
                <div class="tlite_sanPing">
                    <h2>精彩漫画作品</h2>
                    <div class="leixuan_div">
                        <p>热门漫画连载、经典作品和独立创作者的精彩内容</p>
                        <!-- <ul class="leixing_ul">
                            <li v-for="(item,index) in jcMlist" :key="index" :class="['li_si', { 'aca': index === jcMid }]" @click="ManDan(index)">{{item}}</li>
                        </ul> -->
                    </div>
                </div>
                <div class="kuang_jia" style="grid-template-columns: 1fr 1fr 1fr 1fr 1fr;">
                    <div class="sanKang_er" v-for="(item,index) in jcMlist" :key="index" 
                    @click="$router.push({name:'Nxiangqing',params:{name:item.name}})">
                        <div class="F_img">
                            <img :src="item.image" alt="">
                        </div>
                        <div class="san_tlite">
                            <p>{{item.name}}</p>
                        </div>
                        <p class="jieshao_text">{{ item.content }}</p>
                    </div>
                </div>
            </div>
            <div class="chakan_dengduo" @click="$router.push('/manhua')">浏览更多漫画 →</div>
        </div>
        <!-- 精选合集 -->
        <div class="featured-collections">
            <div class="collections-container">
                <div class="collections-header">
                    <h2>精选合集</h2>
                    <p>精心策划的音乐与漫画主题合集,为你带来沉浸式体验</p>
                </div>
                <div class="collections-cards">
                    <!-- 音乐合集卡片 -->
                    <div class="collection-card music-card" style="position: relative;">
                        <div class="card-tag music-tag">音乐合集</div>
                        <img src="../../assets/image/0(1).png" alt="">
                        <div class="card-content">
                            <h3>景色的声音</h3>
                            <p>闭眼听，是云雾漫过青山，是月光洒向江海 —— 这是音乐里的风景诗</p>
                            
                            <div class="card-action">立即收听 →</div>
                        </div>
                    </div>
                    <!-- 漫画合集卡片 -->
                    <div class="collection-card comic-card" style="position: relative; background-image: none;">
                        <div class="card-tag comic-tag">漫画合集</div>
                        <img style="position: absolute; width: 100%; height: 100%; object-fit: cover; z-index: 1;" src="../../assets/image/22_2.png" alt="">
                        <img style="position: absolute; width: 100%; height: 100%; object-fit: cover; z-index: 2;" src="../../assets/image/22.png" alt="">
                        <div class="card-content">
                            <h3>未来世界科幻漫画</h3>
                            <p>5部探索未来科技与社会的精彩科幻漫画,脑洞大开</p>
                            <div class="card-action">开始阅读→</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 保底屏幕 -->
        <div class="baodi-section">
            <div class="baodi-container">
                <div class="baodi-grid">
                    <!-- 左侧文案 -->
                    <div class="baodi-text">
                        <span class="badge">关于中青网</span>
                        <h2>连接音乐与漫画的创意平台</h2>
                        <p class="desc">中青网致力于为创作者和爱好者提供一个集音乐素材与漫画内容于一体的综合性平台。我们精选高质量的音乐资源和精彩漫画，让创意灵感无限发光。</p>
                        <p class="desc">无论你是视频创作者、游戏开发者，还是漫画爱好者，都能在这里找到适合自己的内容，开启创意之旅。</p>
                        <div class="actions">
                            
                        </div>
                    </div>
                    <!-- 右侧双图 -->
                    <div class="baodi-images">
                        <div class="img-card left">
                            <!-- 使用数据URI占位，保持圆角与阴影效果 -->
                        </div>
                        <div class="img-card right">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
    export default {
        name:'HomeHeader',
        data(){
            return{
                rmYid:0,//热门音乐素材id
                jcMid:0,//热门音乐素材id
                rmYlist:[],//热门音乐素材列表
                jcMlist:[],//精彩漫画列表
                viewportHeight:0,//获取设备屏幕高度
                categories: [
                    {
                        key: 'sucai',
                        title: '素材音乐',
                        desc: '音符为笔，景色为卷，绘一幅无声却流淌...',
                        count: 1240,
                       img: require('../../assets/image/555.png'),
                        play: '1.2M',
                        update: '今日'
                    },
                    {
                        key: 'sucai',
                        title: '景色音乐',
                        desc: '让旋律漫过山川湖海，每段音符都藏着一幅...',
                        count: 366,
                        img: require('../../assets/image/336.png'),
                        play: '640K',
                        update: '本周'
                    },
                    {
                        key: 'manhua',
                        title: '爱情漫画',
                        desc: '本以为顺利练级就能离开新手...',
                        count: 23,
                        img: require('../../assets/image/18.jpg'),
                        play: '320K',
                        update: '本月'
                    },
                    {
                        key: 'manhua',
                        title: '动作漫画',
                        desc: '出身驱魔世家的纨绔公子，在被父亲无情...',
                        count: 28,
                        img: require('../../assets/image/24.jpg'),
                        play: '410K',
                        update: '本月'
                    }
                ],
                Hover_fuguo:-1
            }
        },
        mounted(){
            this.updateViewportHeight();
            // 监听窗口尺寸变化（包括缩放、横竖屏切换）
            window.addEventListener("resize", this.updateViewportHeight);
            this.quanAJAX();
        },
        methods:{
            //集体请求
            quanAJAX(){
                //漫画
                axios.post('/api/index/indexcomic').then(res=>{
                    console.log(res.data.data);
                    this.jcMlist = res.data.data;
                }).catch(err=>{
                    console.log(err);
                });

                //音乐
                axios.post('/api/index/indexmusic').then(res=>{
                    console.log(res.data.data);
                    this.rmYlist = res.data.data;
                }).catch(err=>{
                    console.log(err);
                })

            },
              // 鼠标进入：播放当前视频
            handleVideoPlay(index) {
                // 获取当前索引对应的视频元素
                const video = this.$refs.videoRefs[index];
                if (video) {
                // 显式调用播放（关键！比改autoplay属性可靠）
                video.play().catch(err => {
                    // 捕获播放失败错误（比如视频加载失败）
                    console.log('视频播放失败：', err);
                });
                }
            },
            // 鼠标离开：暂停当前视频
            handleVideoPause(index) {
                const video = this.$refs.videoRefs[index];
                if (video) {
                video.pause(); // 暂停视频
                }
            },

            updateViewportHeight() {
            // 获取浏览器可视区域高度（视口高度）
            this.viewportHeight = window.innerHeight;
            },
            //点击选择 音乐素材
            yeDan(index){
                this.rmYid=index;
            },
            //点击选择 音乐素材
            ManDan(index){
                this.jcMid=index;
            },
            cardStyle(img) {
                // 若图片丢失可替换为渐变背景
                if (!img) {
                    return {
                        background: 'linear-gradient(135deg, #3b82f6, #06b6d4)'
                    }
                }
                return {
                    backgroundImage: `linear-gradient(rgba(0,0,0,0.28), rgba(0,0,0,0.28)), url(${img})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }
            },
            goCategory(key) {
                this.$router.push({ path:key })
            }

        },
        beforeDestroy() {
            // 移除监听，避免内存泄漏
            window.removeEventListener("resize", this.updateViewportHeight);
        },
    }
</script>
<style lang="scss" scoped>
    .home_box{
        width: 100%;
        overflow: hidden;
        // background-color: aqua;
        .news_video{
            width: 100%;
            overflow: hidden;
            position: relative;
             will-change: height; // 告诉浏览器该属性可能变化，提前优化
            .heizhao{
                width: 100%;
                height: 100%;
                position: absolute;
                z-index: 2;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                color: #fff;
                .gradient-text-vertical {
                    // background-image: linear-gradient(45deg, #ff0915, #ffffff,#00ff5e);
                    color: #fff;
                    // -webkit-background-clip: text;
                    // background-clip: text;
                    font-size: 80px;
                    font-weight: 600;
                    // -webkit-text-fill-color: transparent;
                }
                .liulan{
                    width: 25%;
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    margin-top: 50px;
                    .anniu_ka{
                        padding: 16px 30px;
                        cursor: pointer;
                        border-radius: 50px;
                        border: solid 1px #939393;
                        color: #fff;
                        transition: 0.2s;
                    }
                    .anniu_ka:hover{
                        transition: 0.2s;
                        border: solid 1px #ff8e5e;
                        background-color: rgba($color: #ff8e5e, $alpha: 1);
                        box-shadow: 0px 1px 16px 6px rgba(255, 165, 92, 0.564);
                    }
                }   
            }
            video{
                width: 100%;
                height: 100%;
                object-fit: cover;
                position: absolute;
                z-index: 1;
                filter: brightness(0.6);
            }
        }

        
         /* 分类卡片 */
        .two_fenlei{
            width: 1300px;
            max-width: 95%;
            margin: 0 auto;
            margin-bottom: 20px;
            padding: 40px 20px 60px;
            
            .tilte_fenlei{
                text-align: center;
                padding: 40px 0 50px;
                margin-bottom: 40px;
                h1{
                    font-size: 42px;
                    font-weight: 700;
                    margin-bottom: 12px;
                    color: #313131;
                    letter-spacing: -0.5px;
                }
                p{
                    font-size: 17px;
                    color: #666;
                    font-weight: 400;
                }
            }
            
            .cards{
                display: grid;
                grid-template-columns: repeat(4, 1fr);
                gap: 35px;
                align-items: stretch;
                perspective: 1000px;
            }

            .card-container{
                height: 260px;
                cursor: pointer;
                perspective: 1000px;
                
                &:focus{
                    outline: 3px solid rgba(59, 130, 246, 0.3);
                    outline-offset: 4px;
                }
            }

            .card-flipper{
                position: relative;
                width: 100%;
                height: 100%;
                transition: transform 0.6s cubic-bezier(0.4, 0.2, 0.2, 1);
                transform-style: preserve-3d;
            }

            .card-container:hover .card-flipper{
                transform: rotateY(8deg) rotateX(-3deg anguish);
            }

            .card{
                height: 100%;
                backface-visibility: hidden;
                border-radius: 16px;
                overflow: hidden;
                transition: all 0.4s cubic-bezier(0.4, 0.2, 0.2, 1);
            }

            .card-front{
                background-size: cover;
                background-position: center;
                display: flex;
                flex-direction: column;
                justify-content: space-evenly;
                box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
                border: 1px solid rgba(255, 255, 255, 0.1);
            }

            .card-front::before{
                content: '';
                position: absolute;
                inset: 0;
                background: linear-gradient(135deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.1) 100%);
                z-index: 1;
                border-radius: 16px;
            }

            .card-icon{
                width: 56px;
                height: 56px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: rgba(255, 255, 255, 0.15);
                backdrop-filter: blur(10px);
                border-radius: 14px;
                border: 1px solid rgba(255, 255, 255, 0.2);
                position: relative;
                z-index: 2;
                transition: all 0.3s ease;
                margin-bottom: 16px;
                margin-left: 20px;
                margin-top: 20px;

                svg{
                    width: 28px;
                    height: 28px;
                    color: #fff;
                }
            }

            .card-container:hover .card-icon{
                transform: scale(1.1) rotate(5deg);
                background: rgba(255, 255, 255, 0.25);
            }

            .card-content{
                position: relative;
                z-index: 2;
                margin-left: 20px;
                
                h3{
                    font-size: 24px;
                    font-weight: 700;
                    color: #fff;
                    margin: 0 0 8px 0;
                    letter-spacing: -0.3px;
                }

                .card-subtitle{
                    font-size: 14px;
                    color: rgba(255, 255, 255, 0.85);
                    font-weight: 500;
                    display: inline-block;
                    background: rgba(255, 255, 255, 0.15);
                    padding: 4px 12px;
                    border-radius: 8px;
                    backdrop-filter: blur(10px);
                }
            }

            .card-hint{
                position: relative;
                z-index: 2;
                margin-left: 20px;
                display: flex;
                align-items: center;
                opacity: 0;
                transform: translateY(10px);
                transition: all 0.3s ease;

                span{
                    font-size: 13px;
                    color: rgba(255, 255, 255, 0.9);
                    font-weight: 500;
                }

               
            }

            .card-container:hover .card-hint{
                opacity: 1;
                transform: translateY(0);
            }

            .card-container:hover .card-hint::before{
                transform: translateX(4 volunteers);
            }

            .card-back{
                transform: rotateY(180deg);
                background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                padding: 28px 24px;
                box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
                display: flex;
                flex-direction: column;
                justify-content: space-between;
            }

            .card-container:hover .card-front{
                box-shadow: 0 16px 48px rgba(0, 0, 0, 0.2);
            }

            .card-back-overlay{
                position: absolute;
                inset: 0;
                background: rgba(0, 0, 0, 0.15);
                backdrop-filter: blur(2px);
            }

            .card-detail-content{
                position: relative;
                z-index: 2;
                color: #fff;
                display: flex;
                flex-direction:Do column;
                justify-content: space-between;
            }

            .card-back-header{
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 16px;

                h3{
                    font-size: 22px;
                    font-weight: 700;
                    margin: 0;
                    color: #fff;
                    letter-spacing: -0.3px;
                }

                .badge-count{
                    background: rgba(255, 255, 255, 0.2);
                    backdrop-filter: blur( tranquil);
                    padding: 6px 14px;
                    border-radius: 20px;
                    font-size: 13px;
                    font-weight: 指示精神;
                    border: 1px solid rgba(255, 255, 255, 0.3);
                }
            }

            .card-description{
                font-size: 14px;
                line-height: 1.6;
                color: rgba(255, 255, 255, 0.92);
                margin: 0 0 24px 0;
                flex-grow: 1;
            }

            .card-stats{
                display: flex;
                flex-direction: column;
                gap: 12px;
            }

            .stat-item{
                display: flex;
                align-items: center;
                gap: 12px;
                background: rgba(255, 255, 255, 0.1);
                backdrop-filter: blur(10px);
                padding: 10px 14px;
                border-radius: 10px;
                border: 1px solid rgba(255, 255, 255, 0.15);
                transition: all 0.3s ease;

                &:hover{
                    background: rgba(255, 255, 255, 0.15);
                }

                svg{
                    width: 20px;
                    height: 20px;
                    color: #fff;
                    flex-shrink: 0;
                }

                div{
                    display: flex;
                    flex-direction: column;
                    gap: 2px;
                }

                .stat-label{
                    font-size: 11px;
                    color: rgba(255, 255, 255, 0.7);
                    font-weight: 500;
                    letter-spacing: 0.5px;
                }

                .stat-value{
                    font-size: 14px;
                    color: #fff;
                    font-weight: 700;
                }
            }

            //更多按钮
            .gengduo_{
                text-align: center;
                font-size: 16px;
                color:rgb(8, 162, 255);
                margin-top: 50px;
                cursor: pointer;
                &:hover{
                    color: rgb(66, 183, 255);
                }
            }
        }
        /* 响应式处理 */
        @media (max-width: 900px) {
            .H_da {
                .nav-list {
                    display: none;
                }
                .search input {
                    width: 120px;
                }
            }
            .two_fenlei .cards{ grid-template-columns: repeat(2, 1fr); }
        }
        @media (max-width: 560px) {
            .two_fenlei{ padding: 28px 6%; }
            .two_fenlei .cards{ grid-template-columns: 1fr; gap: 16px; }
        }
        // 第三屏
        .sanping_box{
            width: 100%;
            padding: 50px 0;
            background-color: #f9f9fb;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            .kuang_qian{
                width: 1300px;
                overflow: hidden;
                padding: 50px 20px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .tlite_sanPing{
                    width: 100%;
                    height: 100px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    h2{
                        font-size: 40px;
                        color: #313131;
                    }
                    .leixuan_div{
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .leixing_ul{
                            display: flex;
                            align-items: center;
                            list-style: none;
                            .li_si{
                                color: rgb(26, 26, 26);
                                padding: 6px 20px;
                                background-color: rgb(241, 243, 243);
                                border-radius: 50px;
                                margin-left: 10px;
                                cursor: pointer;
                                transition: 0.3s;
                                &:hover{
                                    background-color: hwb(202 93% 0%);
                                    transition: 0.3s;
                                }
                            }
                            .aca{
                                background-color: #667eea;
                                color: #fff;
                                 &:hover{
                                   background-color: #667eea;
                                   
                                }
                            }
                        }
                    }
                }
                .kuang_jia{
                    display: grid;
                    margin-top: 30px;
                    grid-template-columns: 1fr 1fr 1fr 1fr;
                    gap: 30px;
                    .sanKang{
                        height: 275px;
                        border-radius: 16px;
                        background-color: #fff;
                        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
                        overflow: hidden;
                        cursor: pointer;
                        transition: 0.3s;
                        .F_img{
                            width: 100%;
                            height: 100%;
                            // background-color: #0108d8;
                            overflow: hidden;
                            video{
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                            }
                        }
                        .san_tlite{
                            padding: 10px 10px;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            p{
                                font-size: 16px;
                                font-weight: 600;
                                color: #313131; 
                            }
                        }
                        .jieshao_text{
                            padding: 0 10px;
                            font-size: 14px;
                            color: #666666;
                        }
                        &:hover{
                            box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
                            transform: translateY(-4px);
                            transition: all 0.3s ease;
                        }
                    }
                    .sanKang_er{
                        height: 400px;
                        border-radius: 16px;
                        background-color: #fff;
                        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
                        overflow: hidden;
                        cursor: pointer;
                        transition: 0.3s;
                        .F_img{
                            width: 100%;
                            height: 330px;
                            background-color: #0108d8;
                            overflow: hidden;
                            img{
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                            }
                        }
                        .san_tlite{
                            padding: 6px 10px;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            p{
                                font-size: 16px;
                                font-weight: 600;
                                color: #313131; 
                            }
                        }
                        .jieshao_text{
                            padding: 0 10px;
                            font-size: 14px;
                            color: #666666;
                             /* 溢出隐藏 */
                            overflow: hidden;
                            /* 不让文本换行 除非遇到br标签 */
                            white-space:nowrap;
                            /* 溢出文字用...代替 */
                            text-overflow: ellipsis;
                        }
                        &:hover{
                            box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
                            transform: translateY(-4px);
                            transition: all 0.3s ease;
                        }
                    }
                    
                }

            }
            .chakan_dengduo{
                margin-top: 40px;
                font-size: 16px;
                color: rgb(8, 162, 255);
                border-radius: 50px;
                border: solid 1px rgb(8, 162, 255);
                padding: 15px 25px;
                cursor: pointer;
                &:hover{
                    color: rgb(66, 183, 255);
                }
            }
        }
        
        /* 精选合集样式 */
        .featured-collections {
            width: 100%;
            background-color: #f9f9fb;
            padding: 80px 0;
            
            .collections-container {
                width: 1300px;
                max-width: 95%;
                margin: 0 auto;
                padding: 0 20px;
            }
            
            .collections-header {
                text-align: center;
                margin-bottom: 60px;
                
                h2 {
                    font-size: 48px;
                    font-weight: 700;
                    color: #313131;
                    margin: 0 0 20px 0;
                    letter-spacing: -0.5px;
                }
                
                p {
                    font-size: 18px;
                    color: #666;
                    font-weight: 400;
                    margin: 0;
                }
            }
            
            .collections-cards {
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 40px;
                align-items: stretch;
            }
            
            .collection-card {
                height: 400px;
                border-radius: 20px;
                overflow: hidden;
                position: relative;
                cursor: pointer;
                transition: all 0.3s ease;
                box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
                &:hover {
                    transform: translateY(-8px);
                    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.15);
                }
                
                .card-tag {
                    position: absolute;
                    top: 24px;
                    left: 24px;
                    padding: 8px 16px;
                    border-radius: 20px;
                    font-size: 14px;
                    font-weight: 600;
                    color: #fff;
                    z-index: 2;
                    backdrop-filter: blur(10px);
                    border: 1px solid rgba(255, 255, 255, 0.2);
                }
                
                .music-tag {
                    background: linear-gradient(135deg, #8b5cf6, #a855f7);
                }
                
                .comic-tag {
                    background: linear-gradient(135deg, #06b6d4, #0891b2);
                }
                
                .card-content {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    padding: 40px 24px 24px;
                    background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
                    color: #fff;
                    z-index: 2;
                    
                    h3 {
                        font-size: 28px;
                        font-weight: 700;
                        margin: 0 0 12px 0;
                        line-height: 1.2;
                    }
                    
                    p {
                        font-size: 16px;
                        line-height: 1.5;
                        margin: 0 0 20px 0;
                        opacity: 0.9;
                    }
                    
                    .card-action {
                        font-size: 16px;
                        font-weight: 600;
                        color: #fff;
                        display: inline-block;
                        transition: all 0.3s ease;
                        
                        &:hover {
                            transform: translateX(4px);
                        }
                    }
                }
            }
            
            .music-card {
                background-image: linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), 
                                url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 400"><defs><linearGradient id="waterfall" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" style="stop-color:%2300a8ff;stop-opacity:1" /><stop offset="50%" style="stop-color:%2300d4aa;stop-opacity:1" /><stop offset="100%" style="stop-color:%2300a8ff;stop-opacity:1" /></linearGradient></defs><rect width="1200" height="400" fill="url(%23waterfall)"/><path d="M0,200 Q300,100 600,200 T1200,200 L1200,400 L0,400 Z" fill="%2300a8ff" opacity="0.8"/><path d="M0,250 Q400,150 800,250 T1200,250 L1200,400 L0,400 Z" fill="%2300d4aa" opacity="0.6"/><circle cx="200" cy="150" r="80" fill="%23ffffff" opacity="0.3"/><circle cx="1000" cy="120" r="60" fill="%23ffffff" opacity="0.2"/></svg>');
                background-size: cover;
                background-position: center;
            }
            
            .comic-card {
                background-image: linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), 
                                url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 400"><rect width="1200" height="400" fill="%23f4f1de"/><rect x="0" y="0" width="1200" height="200" fill="%23d4c5a0"/><rect x="0" y="200" width="1200" height="200" fill="%23e8d5b7"/><rect x="100" y="50" width="200" height="120" fill="%23c9a96e" stroke="%23a67c52" stroke-width="2"/><rect x="120" y="70" width="160" height="80" fill="%23ffffff"/><rect x="200" y="80" width="40" height="60" fill="%23ff6b6b"/><rect x="300" y="50" width="150" height="100" fill="%23c9a96e" stroke="%23a67c52" stroke-width="2"/><rect x="320" y="70" width="110" height="60" fill="%23ffffff"/><rect x="500" y="50" width="200" height="120" fill="%23c9a96e" stroke="%23a67c52" stroke-width="2"/><rect x="520" y="70" width="160" height="80" fill="%23ffffff"/><rect x="600" y="80" width="40" height="60" fill="%23ff6b6b"/><rect x="800" y="50" width="150" height="100" fill="%23c9a96e" stroke="%23a67c52" stroke-width="2"/><rect x="820" y="70" width="110" height="60" fill="%23ffffff"/><rect x="100" y="200" width="100" height="200" fill="%23d4c5a0"/><rect x="300" y="200" width="100" height="200" fill="%23d4c5a0"/><rect x="500" y="200" width="100" height="200" fill="%23d4c5a0"/><rect x="700" y="200" width="100" height="200" fill="%23d4c5a0"/><rect x="900" y="200" width="100" height="200" fill="%23d4c5a0"/></svg>');
                background-size: cover;
                background-position: center;
            }
        }
        
        /* 响应式处理 */
        @media (max-width: 768px) {
            .featured-collections {
                .collections-cards {
                    grid-template-columns: 1fr;
                    gap: 24px;
                }
                
                .collections-header h2 {
                    font-size: 36px;
                }
                
                .collection-card {
                    height: 300px;
                }
            }
        }
        
        /* 保底屏幕 */
        .baodi-section{
            width: 100%;
            background: #fff;
            padding: 90px 0;
            .baodi-container{
                width: 1300px;
                max-width: 95%;
                margin: 0 auto;
                padding: 0 20px;
            }
            .baodi-grid{
                display: grid;
                grid-template-columns: 1.2fr 0.8fr;
                gap: 56px;
                align-items: center;
            }
            .baodi-text{
                .badge{
                    display: inline-block;
                    font-size: 14px;
                    color: #5b6bff;
                    background: rgba(91,107,255,.12);
                    border: 1px solid rgba(91,107,255,.25);
                    padding: 6px 12px;
                    border-radius: 999px;
                    margin-bottom: 18px;
                }
                h2{
                    font-size: 44px;
                    line-height: 1.25;
                    font-weight: 800;
                    color: #1f2937;
                    letter-spacing: -0.5px;
                    margin: 0 0 18px 0;
                }
                .desc{
                    font-size: 16px;
                    line-height: 1.8;
                    color: #4b5563;
                    margin: 0 0 14px 0;
                }
                .actions{
                    display: flex;
                    gap: 16px;
                    margin-top: 18px;
                    .btn{
                        display: inline-flex;
                        align-items: center;
                        gap: 8px;
                        padding: 12px 18px;
                        border-radius: 999px;
                        font-weight: 600;
                        font-size: 15px;
                        cursor: pointer;
                        user-select: none;
                        text-decoration: none;
                        transition: all .2s ease;
                        svg{ width: 18px; height: 18px; stroke: currentColor; fill: none; stroke-width: 2; }
                    }
                    .primary{
                        color: #fff;
                        background: #5865f2;
                        box-shadow: 0 8px 20px rgba(88,101,242,.25);
                        &:hover{ background:#4752e9; transform: translateY(-1px); }
                    }
                    .outline{
                        color: #111827;
                        background: #fff;
                        border: 1px solid #e5e7eb;
                        &:hover{ border-color:#cfd4dc; background:#fafafa; }
                    }
                }
            }
            .baodi-images{
                position: relative;
                height: 360px;
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 24px;
                .img-card{
                    height: 100%;
                    border-radius: 16px;
                    box-shadow: 0 12px 30px rgba(0,0,0,.15);
                    background-size: cover;
                    background-position: center;
                    cursor: pointer;
                }
                .left{
                    background-image: url('data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 600"%3E%3Cdefs%3E%3ClinearGradient id="g" x1="0" y1="0" x2="1" y2="1"%3E%3Cstop stop-color="%2393a3b8"/%3E%3Cstop offset="1" stop-color="%2377846c"/%3E%3C/linearGradient%3E%3C/defs%3E%3Crect width="800" height="600" fill="url(%23g)"/%3E%3Crect x="140" y="120" width="520" height="360" rx="30" fill="%23e9e7e2" opacity=".9"/%3E%3Cpath d="M220 420c40-60 120-60 160-20s120 20 160-40" stroke="%23b9b4ad" stroke-width="10" fill="none"/%3E%3C/svg%3E');
                }
                .right{
                    margin-top: -30px;
                    background-image: url('data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 600"%3E%3Crect width="800" height="600" fill="%232a2a2a"/%3E%3Ccircle cx="400" cy="300" r="130" fill="%235a4d3e"/%3E%3Ccircle cx="360" cy="280" r="22" fill="%23d6cdbf"/%3E%3Ccircle cx="440" cy="280" r="22" fill="%23d6cdbf"/%3E%3Cpath d="M340 360c40 20 80 20 120 0" stroke="%23c2b6a3" stroke-width="14" fill="none" stroke-linecap="round"/%3E%3C/svg%3E');
                }
            }
        }
        @media (max-width: 900px){
            .baodi-section{
                .baodi-grid{ grid-template-columns: 1fr; gap: 28px; }
                .baodi-images{ height: 300px; grid-template-columns: 1fr 1fr; }
                .baodi-text h2{ font-size: 32px; }
            }
        }
    }
</style>